const BASE_URL = "https://hple.moh.gov.et/hple/api/";
const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem("token");

  // Check if we are sending a file (FormData)
  const isFormData = options.body instanceof FormData;

  // 1. Setup Headers
  const headers = {
    // ONLY set Content-Type to JSON if it's NOT FormData
    // Browsers must set the boundary themselves for FormData
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...options.headers,
  };

  // 2. Specific Public Routes
  const publicRoutes = [
    "auth/login",
    "auth/forgotPassword",
    "auth/resetPassword",
    "auth/fayda/callback",
    "auth/fayda/send-otp",
    "auth/fayda/link-start",
    "auth/fayda/finalizelink",
    "users/note",
    "users/results/public",
    "users/results/public/analysis",
  ];

  // Using .some with a specific check to ensure auth/logout isn't skipped
  const isPublic =
    publicRoutes.some((path) => endpoint.includes(path)) ||
    /^users\/[^/]+\/check(\?.*)?$/.test(endpoint);

  // 3. Add Token if available and route is not public
  if (token && !isPublic) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    method: options.method || "GET",
    headers,
  };

  // 4. Transform Body
  // Stringify ONLY if it's a standard object and not FormData
  if (options.body && typeof options.body === "object" && !isFormData) {
    config.body = JSON.stringify(options.body);
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, config);

  // 6. Safe Parse Response
  const text = await response.text();
  let result;
  try {
    result = text ? JSON.parse(text) : {};
  } catch (err) {
    result = { message: err.message };
  }

  if (!response.ok) {
    throw new Error(
      result.message || `Error ${response.status}: Request failed`
    );
  }

  return result;
};

export default apiRequest;
